import getDefaultTab from "../get-default-tab";
import { isActive } from "../tournament-filters";
import { isMobile } from "../breakpoints";
import Loading from "./loading";
import pure from "./higher-order/pure";
import React from "react";
import SideFiltersContainer from "../containers/side-filters-container";
import TournamentList from "./tournament-list";
import TournamentListTabs from "../containers/tournament-list-tabs";

export default class LobbyTournamentList extends React.PureComponent {
  constructor(props) {
    super(props);
    if (props.list === "started") {
      props.onViewStartedTournaments();
    }
    this.state = {
      pageSize: isMobile() ? 20 : 100
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidUpdate({ list: prevList, location: prevLocation }) {
    var { communications, list, location, onViewStartedTournaments, tags } = this.props;
    if (communications.getIn(["sessionConnect", "state"]) === "success") {
      if (list === "started" && list !== prevList) {
        onViewStartedTournaments();
      }
      var tag = tags.valueSeq().find(t => t.get("name") === list);
      if (tag) {
        if (communications.getIn(["fetchStartedTournaments", "state"]) === undefined || isActive({ key: "started", group: "status" }, location) && !isActive({ key: "started", group: "status" }, prevLocation)) {
          onViewStartedTournaments(tag.get("name"));
        }
      }
    }
  }

  loadMore() {
    var { pageSize } = this.state;
    this.setState({ pageSize: pageSize + 10 }); // eslint-disable-line react/no-set-state
  }

  render() {
    var { pageSize } = this.state;
    var { communications, filteredTournaments, list, location, session, tournaments } = this.props;
    const whichList = list || getDefaultTab(session);
    const tsForPage = filteredTournaments.take(pageSize);
    var loadMoreButton;
    if (tournaments.count() > pageSize) {
      loadMoreButton = (
        <button className="btn btn--is-block btn--load-more" onClick={this.loadMore} type="button">
          Show More Tournaments
        </button>
      );
    }

    var loadingUpcoming = communications.getIn(["fetchUpcomingTournaments", "state"]) !== "success";
    var loadingStarted = communications.getIn(["fetchStartedTournaments", "state"]) === "in progress";
    var tournamentList;
    if (loadingUpcoming || loadingStarted) {
      tournamentList = <LoadingTournaments />;
    } else {
      tournamentList = (
        <TournamentList
          location={location}
          tournaments={tsForPage} />
      );
    }

    return (
      <div className="l-wrapper">
        <SideFiltersContainer
          list={whichList}
          location={location}
          tournaments={tournaments}>
          <TournamentListTabs active={whichList} />

          {tournamentList}

          {loadMoreButton}
        </SideFiltersContainer>
      </div>
    );
  }
}

var LoadingTournaments = pure(function LoadingTournaments() {
  return (
    <div className="tournament-table_wrapper">
      <div className="tournament-table_list">
        <Loading dark />
      </div>
    </div>
  );
});
